import React from 'react';
import classNames from 'classnames/bind';

import { Skeleton } from 'components';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const SkeletonTable = () => (
  <div className={cx('table-body')}>
    {Array.from(
      Array(5).keys(),
    ).map((skeletonRow) => (
      <Skeleton
        key={skeletonRow}
        className={cx(skeletonRow ? 'table-body__row' : 'table-body__head')}
      />
    ))}
  </div>
);
